export default "__VITE_ASSET__PjjAQQxd__"